import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Usar requestAnimationFrame para asegurar que el elemento está en el DOM
    requestAnimationFrame(() => {
      if (!this.element.classList.contains("shown-toast")) {
        const toast = new bootstrap.Toast(this.element)
        toast.show()
        this.element.classList.add("shown-toast")
      }
    })
  }
}
